import { Stack } from '@backyard-ui/core';

import { useProductStore } from '@/presenters/store/catalog/product';

import { Disclaimer } from '../Disclaimer';
import { ErrorDisclaimer } from '../ErrorDisclaimer';
import { ModalityItem } from '../ModalityItem';

export default function Modalities() {
  const currentSeller = useProductStore((store) => store.currentSeller);
  const { data: shipments, isFetched } = useProductStore(
    (store) => store.shipments
  );

  const currentShipment = shipments[currentSeller.id];

  if (isFetched && !currentShipment) {
    return <ErrorDisclaimer />;
  }

  if (!currentShipment) {
    return null;
  }

  const expressModality = currentShipment.modalities.find(
    ({ type }) => type === 'express' || type === 'marketplace_express'
  );

  const shouldShowCheapestModality =
    currentShipment.chepeastModality.type !== expressModality?.type;

  return (
    <Stack direction="column" spacing="4">
      {currentShipment.pickupInStore && (
        <ModalityItem modality={currentShipment.pickupInStore} />
      )}
      {shouldShowCheapestModality && (
        <ModalityItem
          modality={currentShipment.chepeastModality}
          data-testid="cheapest-modality"
        />
      )}
      {expressModality && <ModalityItem modality={expressModality} />}
      <Disclaimer />
    </Stack>
  );
}
